module.exports = __webpack_public_path__ + "img/13.3abd0be9.jpg";